export default "__VITE_ASSET__BMKn7_ub__"